import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKgProductPlaceholder = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 2,
		fill: "none",
		stroke: "currentColor",
		strokeLinejoin: "round",
		className: "nc-icon-wrapper",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M4 10h40" }),
			/* @__PURE__ */ _jsx("path", { d: "M44 46H4V10l8-8h24l8 8z" }),
			/* @__PURE__ */ _jsx("path", { d: "M34 20c0 5.5-4.5 10-10 10s-10-4.5-10-10" })
		]
	})
});
export default SvgKgProductPlaceholder;
